import { AuthDomain } from 'auth-lib-front';
import { DomainV2 } from 'troppus-common/domain';

import Project = AuthDomain.Object.Project;
import ImportTableDefinition = DomainV2.Import.ImportTableDefinition;

const listPrefixInner = (projectId: Project.Id) => ['troppus', 'importTableDefinition', 'list', projectId] as const;

export const importTableDefinitionQueryKeys = {
  /** 指定プロジェクトの list クエリすべてにマッチさせるときに invalidate で使う（sourceSystem で絞っていない行もまとめて無効化） */
  listPrefix: listPrefixInner,

  list: (projectId: Project.Id, sourceSystemId?: ImportTableDefinition['sourceSystemId']) =>
    [...listPrefixInner(projectId), sourceSystemId ?? 'all'] as const,
  detail: (projectId: Project.Id, id: ImportTableDefinition.Id) => ['troppus', 'importTableDefinition', 'detail', projectId, id] as const,
  revisions: (projectId: Project.Id, id: ImportTableDefinition.Id) =>
    ['troppus', 'importTableDefinition', 'revisions', projectId, id] as const,
};
